<template>
	<div>
		<CheckCircleIcon class="mx-auto size-16 text-won-green" />

		<h2 class="mt-6 text-center text-[20px] leading-[28px] font-semibold text-gray-900">
			Subscription cancelled
		</h2>
		<p class="mt-0.5 text-center text-[14px] leading-[20px] font-normal text-gray-500">
			Your subscription and all the premium features will remain active until
			<span class="font-medium text-gray-900">{{ formattedEndsAt }}.</span>
			{{ encouragement }}
		</p>

		<div class="mt-6 flex flex-col items-center gap-2">
			<button
				type="button"
				class="
					flex h-9 w-full max-w-[320px] items-center justify-center rounded-md bg-won-green
					px-3 text-[16px] leading-[20px] font-medium text-white hover:bg-won-green-dark
				"
				@click="emit('dismiss')"
			>
				See you!
			</button>

			<button
				type="button"
				:disabled="isReactivating"
				class="
					flex h-9 w-full max-w-[320px] items-center justify-center rounded-md bg-gray-100
					px-3 text-[16px] leading-[20px] font-medium text-gray-900
					hover:bg-gray-200 disabled:cursor-default
				"
				@click="emit('reactivate')"
			>
				<template v-if="isReactivating">
					<LoadingIcon
						color="#111827"
						margin=""
					/>
				</template>
				<template v-else>
					Reactivate Subscription
				</template>
			</button>
		</div>
	</div>
</template>

<script setup>
import { computed } from 'vue';
import { CheckCircleIcon } from '@heroicons/vue/24/outline';
import moment from 'moment';

import LoadingIcon from '../../../../icons/loading-spinner.vue';

const props = defineProps({
	/**
	 * Raw `user.current_plan.ends_at` — the date the cancelled plan stays active until.
	 */
	endsAt: {
		type: String,
		required: true,
	},
	/**
	 * The branch's warm closing line, from ENCOURAGEMENT_BY_REASON. Only the branches
	 * that part on good terms pass one; the rest leave it empty.
	 */
	encouragement: {
		type: String,
		default: '',
	},
	isReactivating: {
		type: Boolean,
		default: false,
	},
});

const emit = defineEmits(['dismiss', 'reactivate']);

const formattedEndsAt = computed(() => moment(props.endsAt).format('MM/DD/YYYY'));
</script>
